import { SxProps } from '@mui/material';

export const getWarningRowStyling = (): SxProps => {
  return {
    '& .row-overdue': {
      backgroundColor: '#e4bab3 !important',
    },
    '& .row-overdue:hover': {
      backgroundColor: '#e4b4ab !important',
    },
    '& .row-danger': {
      backgroundColor: '#e4c8c3 !important',
    },
    '& .row-danger:hover': {
      backgroundColor: '#e4c2bc !important',
    },
    '& .row-warning': {
      backgroundColor: '#fff4d8 !important',
    },
    '& .row-warning:hover': {
      backgroundColor: '#fff1cc !important',
    },
  };
};
